















import {
  defineComponent,
  ComputedRef,
  computed,
  ref
} from '@vue/composition-api';

import {
  Dga,
  PieChart,
  PreviewDocuments,
  UpsellPackages,
  GenericSections,
  ContractUpsell,
  ExtraServices
} from '../shared-steps';
import { useSteps } from './handler.hooks';
import { NotaryProduct } from '@ligo/bv-flow/store';
import { paymentRedirect } from '../tools/payment_redirection';
import { reloadPage, endStep } from '../tools/utils';

export default defineComponent({
  name: 'HoldingHandler',
  components: {
    GenericSections,
    PieChart,
    UpsellPackages,
    Dga,
    PreviewDocuments,
    ContractUpsell,
    ExtraServices
  },
  props: {
    notary_product: {
      type: Object as () => NotaryProduct,
      required: true
    }
  },
  setup(props, { root }) {
    const loading = ref(false);
    const currentStep: ComputedRef<number> = computed(() => {
      return props.notary_product.temporalStep;
    });
    const { steps } = useSteps();
    const stepToShow: ComputedRef = computed(() => {
      paymentRedirect(currentStep, props.notary_product, root);
      return steps[currentStep.value];
    });
    const endedStep = () => {
      endStep(currentStep, props.notary_product, root);
      reload();
    };

    const reload = () => {
      reloadPage(loading, root, props.notary_product);
    };

    return { endedStep, stepToShow, loading, reload };
  }
});
